import { AppSlice } from "@/store/app"
import { BOILOUTSlice } from "@/store/boilout"
import { IPQCSlice } from "@/store/ipqc"
import { PackagingSlice } from "@/store/packaging"
import { PackagingV2Slice } from "@/store/packaging-v2"
import { RMPMSlice } from "@/store/rmpm"
import { SessionSlice } from "@/store/session"
import { UserSlice } from "@/store/user"
import {
  StoreApi,
  UseBoundStore,
  StateCreator as ZusStateCreator,
} from "zustand"

export type Store = IPQCSlice &
  BOILOUTSlice &
  AppSlice &
  UserSlice &
  PackagingSlice &
  PackagingV2Slice &
  SessionSlice &
  RMPMSlice & {
    reset(): void
  }

export type StateCreator<Slice> = ZusStateCreator<
  Store,
  [["zustand/immer", never], ["zustand/devtools", never]],
  [],
  Slice
>

type WithSelectors<S> = S extends { getState: () => infer T }
  ? S & { use: { [K in keyof T]: () => T[K] } }
  : never

export const createSelectors = <S extends UseBoundStore<StoreApi<object>>>(
  _store: S
) => {
  const store = _store as WithSelectors<typeof _store>
  store.use = {}
  for (const k of Object.keys(store.getState())) {
    ; (store.use as any)[k] = () => store((s) => s[k as keyof typeof s])
  }

  return store
}
